import { useEffect, useState } from 'react';
import { X } from 'lucide-react';
import type { SystemAnnouncement } from '../types/announcement';
import { announcementService } from '../services/announcementService';

const TYPE_STYLES: Record<string, string> = {
  info: 'bg-blue-900/80 border-blue-500 text-blue-100',
  warning: 'bg-amber-900/80 border-amber-500 text-amber-100',
  maintenance: 'bg-red-900/80 border-red-500 text-red-100',
};

const DISMISSED_KEY = (id: number) => `announcement-${id}-dismissed`;

export function AnnouncementBanner() {
  const [announcements, setAnnouncements] = useState<SystemAnnouncement[]>([]);

  useEffect(() => {
    announcementService
      .getActive()
      .then((data) => {
        const undismissed = data.filter(
          (a) => localStorage.getItem(DISMISSED_KEY(a.id)) !== '1'
        );
        setAnnouncements(undismissed);
      })
      .catch(() => {}); // banner is non-critical
  }, []);

  if (announcements.length === 0) return null;

  const dismiss = (id: number) => {
    localStorage.setItem(DISMISSED_KEY(id), '1');
    setAnnouncements((prev) => prev.filter((a) => a.id !== id));
  };

  return (
    <div className="space-y-px">
      {announcements.map((ann) => (
        <div
          key={ann.id}
          className={`border-b px-4 py-2 flex items-center justify-between ${TYPE_STYLES[ann.type] ?? TYPE_STYLES.info}`}
        >
          <div className="min-w-0 flex-1">
            <span className="font-semibold mr-2 text-sm">{ann.title}</span>
            <span className="text-sm opacity-90">{ann.body}</span>
          </div>
          <button
            onClick={() => dismiss(ann.id)}
            className="ml-4 flex-shrink-0 opacity-75 hover:opacity-100 transition-opacity"
            aria-label="Dismiss announcement"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      ))}
    </div>
  );
}
